export default "__VITE_ASSET__DnPw3ax6__"